import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
export var overflow = {
  AUTO: 'auto',
  HIDDEN: 'hidden'
};
overflow.ALL = _Object$values(overflow);
//# sourceMappingURL=overflow.js.map